module.exports = __webpack_public_path__ + "img/e-class2021_930x620-600x416.a3b210ee.png";